import {QueryFunctionContext} from 'react-query';
import request from '../../axios';

export const getAllComments = async (ctx: QueryFunctionContext) => {
  const {data}: {data: ICommentsList} = await request.get(
    `/api/v2/store/store-comment/${ctx.queryKey[1]}?page=${ctx.queryKey[2]}`,
  );

  return data;
};
